gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const creationsAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const cards = gsap.utils.toArray(".project-card");
      cards.forEach((card) => {
        const cardText = card.querySelector(".project-content");
        const cardExcerpt = card.querySelector(".excerpt");
        //const cardTitle = card.querySelector(".hoverCard__body-text");



        const tl = gsap
          .timeline({
            paused: true,
          })
          .to(cardText, {
            duration: 0.3,
            height: "100%",
          })
          .to(cardExcerpt, {
            display: "block",
            opacity: 1,
          });

        //.to(cardTitle, { duration: 0.5, y: -75 }, "<");
        card.addEventListener("mouseenter", function () {
          tl.play();
        });

        card.addEventListener("mouseleave", function () {
          tl.reverse();
        });

        
      });

      ///GSAP

      const animation = gsap;
      animation.from(".project-card", {
        opacity: 0,
        y: -100,
        stagger: 0.1, // 0.1 seconds between when each ".box" element starts animating
      });
      animation.to(".project-card", {
        y: 0,
        opacity: 1,
        stagger: 0.5, // 0.1 seconds between when each ".box" element starts animating
      });

      //animation.kill();
    });
  },
};

export default creationsAnim;
